import callApi from "Common/utils/apiCaller";
import { showNotification } from "Common/utils/Notification";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Button from "../ButtonComponent/Button";
import CustomInput from "../InputFields/CustomInput";
import CustomTextArea from "../InputFields/CustomTextArea";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import Drawer from "../Drawer";
import checkTypeInput from "../../../constants/contactUs.json";

const ContactUsSegments = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  segmentType,
  toggleVisiblity,
}) => {
  const [email, setEmail] = useState(data?.contact_email?.join(",") || "");
  const [headerText, setHeaderText] = useState(data?.header_text || "");
  const [subHeaderText, setSubHeaderText] = useState(
    data?.subheader_text || ""
  );
  const [phone, setPhone] = useState(data?.contact_phone?.join(",") || "");
  const [address, setAddress] = useState(data?.address?.join(",") || "");
  const [isLoading, setIsLoading] = useState<any>(false);
  const [checkedType, setCheckedType] = useState<any>([]);

  const [formData, setFormData] = useState<any>();

  const [errors, setErrors] = useState({
    email: "",
    headerText: "",
    phone: "",
    address: "",
  });

  const handleFormData = (e) => {
    const { name, value } = e.target;
    let arr = [];
    if (!checkedType?.some((existingItem) => existingItem === name)) {
      arr.push(name);
    }
    setCheckedType((prev) => {
      if (prev?.some((lead) => lead === name)) {
        return prev?.filter((item) => !(item === name));
      }

      return [...prev, ...arr];
    });
  };

  useEffect(() => {
    setFormData((prev) => {
      const updatedFormData = { ...prev };

      checkedType.forEach((item) => {
        updatedFormData[item] = true;
      });

      checkTypeInput.forEach(({ value }) => {
        if (!checkedType.includes(value)) {
          updatedFormData[value] = false;
        }
      });

      return updatedFormData;
    });
  }, [checkedType]);

  useEffect(() => {
    if (!data) return;

    const update = Object.keys(data).filter(
      (key) => data[key] && checkTypeInput.some((item) => item.value === key)
    );

    setCheckedType(update);
  }, [data]);

  const handleSave = async (pageId, id) => {
    const newErrors = {
      email: email?.length === 0 ? "Please enter email." : "",
      headerText: headerText.trim() === "" ? "Please enter header text." : "",
      phone: phone?.length === 0 ? "Please enter phone no." : "",
      address: address?.length === 0 ? "Please enter address." : "",
    };

    setErrors(newErrors);

    if (email?.length === 0 || !headerText || phone?.length === 0) {
      return;
    }
    const payload = {
      segment_type: "contact_us_segments",
      header_text: headerText,
      subheader_text: subHeaderText,
      contact_phone: phone
        ?.trim()
        .split(",")
        ?.map((value) => value.trim()),
      contact_email: email
        ?.trim()
        .split(",")
        ?.map((value) => value.trim()),
      address: address
        ?.trim()
        .split(",")
        ?.map((value) => value.trim()),
      ...formData,
    };

    try {
      setIsLoading(true);
      const response = await callApi(
        `v1/page/${pageId}/segment/${id}/update-info`,
        "post",
        payload
      );
      setIsLoading(false);
      if (response && response?.status === "Success") {
        setLoader(!loader);
        showNotification("ContactUs added successfully!", "success");
      }
    } catch (e) {
      showNotification("An error occurred. Please try again.", "error");
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="header_text"
            type="text"
            value={headerText}
            placeholder="Enter name"
            onChange={(e) => {
              setHeaderText(e.target.value);
              setErrors((prev) => ({ ...prev, ["header_text"]: "" }));
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.header_text}
            error={errors?.headerText}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Sub Header Text"
            name="subheader_text"
            type="text"
            value={subHeaderText}
            placeholder="Enter query type"
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, ["subheader_text"]: "" }));
              setSubHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.subheader_text}
            error={null}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Email"
            name="contact_email"
            type="text"
            value={email}
            placeholder="Enter Email"
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, ["contact_email"]: "" }));
              setEmail(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.contact_email}
            error={errors?.email}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Contact Phone"
            name="contact_phone"
            type="text"
            value={phone}
            placeholder="Enter Phone No"
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, ["contact_phone"]: "" }));
              setPhone(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.contact_phone}
            error={errors?.phone}
          />
        </div>
        {/* hh */}
        <div className="mb-4 xl:col-span-12">
          <CustomTextArea
            label="Address"
            name="address"
            value={address}
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, ["address"]: "" }));
              setAddress(e);
            }}
            versionedValue={versionData?.address}
            isVersioned={versionData ? true : false}
            error={errors?.address}
            placeholder="Enter Address"
            disabled={false}
          />
        </div>

        <div className="grid grid-cols-5 col-span-3 gap-2">
          {checkTypeInput?.map((key) => (
            <label key={key?.label} className="flex items-center space-x-2">
              <input
                type="checkbox"
                name={key.value}
                checked={checkedType?.some((item) => item === key?.value)}
                onChange={handleFormData}
              />
              <span className="capitalize">
                {key?.label?.replace(/([A-Z])/g, " $1")}
              </span>
            </label>
          ))}
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />
          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
    </>
  );
};

export default ContactUsSegments;
